import styled from "styled-components"
import { BotResponseData, ResponseClassification, UserQuestionData } from "../types/MessageData"
import iconInfo from '../images/fa-circle-info-solid.svg';


const BotMessageTraceInfoImg = styled.img<{role: 'user' | 'assistant'}>`
    width: 24px;
    position: absolute;
    left: ${props => props.role === 'assistant' ? "33px" : undefined};
    right: ${props => props.role === 'user' ? "-10px" : undefined};
    top: ${props => props.role === 'user' ? "25px" : '33px'};
    filter: invert(66%) sepia(40%) saturate(6062%) hue-rotate(156deg) brightness(88%) contrast(101%);
`

const classificationLabels: {
    [K in ResponseClassification]: string
} = {
    "fully-answered": "Frage vollständig beantwortet",
    "partly-answered": "Einige der Teilfragen beantwortet",
    "un-answered": "Frage nicht beantwortet",
    "other": "Unbekannt",
    "out-of-scope": "Out-Of-Scope",
    "fixed-answer": "Fixtext Antwort"
};

type MessageDebugInfoProps = { 
    message: BotResponseData | UserQuestionData;
};
export const MessageDebugInfo = ({message}: MessageDebugInfoProps) => {
    if (window.location.host.endsWith('.ch') && window.location.search.indexOf('debug')<0) {
        // don't show on prod site
        return null;
    }
    let infoText = '';
    if (message.role === 'assistant') {
        if (message.tokenUsage) {
            const usage = message.tokenUsage;
            infoText += `Verbrauchte Tokens:\r\n${usage.input} (Input) / ${usage.output} (Output) / ${ usage.total} (Total)\r\n\r\n`;
        }
        infoText += `Hauptthema: ${message.mainTopic || '-'}\r\nUnterthema: ${message.subTopic || '-'}\r\n\r\n`;
        infoText += `Einstufung: ${classificationLabels[message.classification]}\r\n\r\n`
    }
    if (message.role === 'user' && message.preprocessingResult) {
        infoText += message.preprocessingResult.queries.map((q, i) => `Teilfrage ${i+1}: \r\n${q.question} (Query: ${q.query})`).join('\r\n') || 'keine';
        infoText += `\r\n\r\n`
        infoText += `Kontextualisierte Eingabe: ${message.preprocessingResult.contextualized_input}\r\n\r\n`;
        infoText += `Sprache: ${message.preprocessingResult.input_language}\r\n\r\n`;
        if (message.preprocessingResult.focusOnContacts) {
            infoText += `Fokus auf Kontakte/Personen/Funktionen\r\n\r\n`;
        }
        infoText += `Bezug auf Konversation: ${message.preprocessingResult.relies_on_conversation}\r\n\r\n`;
        
    }
    return !infoText ? null: <BotMessageTraceInfoImg src={iconInfo} role={message.role} alt="Info" title={infoText} />;
}